export default __webpack_public_path__ + "static/boiler_w.78cb55099602b5a32e8bc4acc28d4b9e.png";